<template>
  <div :class="{
    'product-list-item': true,
    big: product.portrait,
    'detail-link': detailLink,
    preview: preview,
    'product-has-video': productHasVideo
  }">
    <a
      :href="`/produkt/${product.nr}/${product.slug}`"
      :key="product.id"
      :tabindex="preview ? -1 :24"
      :aria-label="`${product.title} (${product.categories[0]}), ${product.price} € je Packung ansehen`"
    >
    <div v-if="product.bonusProdukt">
      <div :class="`bonus-badge ${productHasVideo ? 'bonus-badge__video' : ''}`">
        <img src="/assets/images/bonus-badge-25euro.png" alt="25,00 € Bonus" class="bonus-badge-image" />
      </div>
    </div>
      <div
        :class="{
          bg: true,
          blur: !product.backgroundThumb || product.backgroundThumb.length <= 0
        }"
        :style="{
          'background-image':
            product.backgroundThumb && product.backgroundThumb.length > 0
              ? 'url(' + product.backgroundThumb + ')'
              : product.thumb && product.thumb.length > 0
              ? 'url(' + product.thumb + ')'
              : 'none'
        }"
        v-on:click.prevent="goToProduct(product)"
      ><span class="hidden">Zum Produkt {{ product.title }}</span></div>

      <div
        aria-label="Produkt ansehen"
        class="pic"
        :style="{
          'margin-top': offsetPicPx,
          'background-image':
            product.thumb && product.thumb.length > 0
              ? 'url(' + product.thumb + ')'
              : 'none'
        }"
        v-on:click.prevent="goToProduct(product)"
      ><span class="hidden">Zum Produkt {{ product.title }}</span></div>

      <img src="/assets/images/card-video-icon.png" class="video-pic" v-if="productHasVideo" :alt="`${product.title}: Video ansehen`" />
      
      <div
        class="info tv"
        v-if="product.tvSpot"
        v-on:click.prevent="goToProduct(product)"
        aria-label="TV Spot ansehen"
      ><span class="hidden">Zum Produkt {{ product.title }}</span></div>
      <div
        class="info"
        v-else-if="product.zeigeAttribut === 'schuss' && product.schuss"
        :aria-label="`${product.schuss} Schuss`"
      >
        <span>{{ product.schuss }}</span>
        <small>Schuss</small>
      </div>
      <div
        class="info"
        v-else-if="product.zeigeAttribut === 'teile' && product.teile"
        :aria-label="`${product.teile} Teile`"
      >
        <small v-if="product.teileUeber">Über</small>
        <span>{{ product.teile }}</span>
        <small>Teile</small>
      </div>
      <div
        class="info"
        v-else-if="product.zeigeAttribut === 'effekthoehe' && product.effekthoehe"
        v-on:click.prevent="goToProduct(product)"
        :aria-label="`${product.effekthoehe} m Effekthöhe`"
      >
        <span>{{ product.effekthoehe }}<small>m</small></span>
        <small>Effekthöhe</small>
      </div>
      <div
        class="info"
        v-else-if="product.zeigeAttribut === 'laenge' && product.laenge"
        v-on:click.prevent="goToProduct(product)"
        :aria-label="`${product.laenge} Sek. Effektdauer`"
      >
        <span>{{ product.laenge }}<small>Sek.</small></span>
        <small>Effektdauer</small>
      </div>
      <div
        class="info"
        v-else-if="product.zeigeAttribut === 'kaliber' && product.kaliber"
        v-on:click.prevent="goToProduct(product)"
        :aria-label="`${product.kaliber} Kaliber`"
      >
        <span>{{ product.kaliber }}</span>
        <small>Kaliber</small>
      </div>

      <h3 v-on:click.prevent="goToProduct(product)" ref="title" :aria-label="`${product.title} ansehen`" class="title-with-package-hint">
        <small>{{ product.categories[0] }}</small
        ><span>{{ product.title }}</span><sup v-if="!preview"><a href="#fn1" id="fn1-link" aria-label="Fußnoten anzeigen" aria-describedby="footnote-label">3</a></sup>
      </h3>
    </a>
    
    <div class="meta">
      <ShoppinglistAddButton :tabindex="24" :productNr="product.nr" :productTitle="product.title" />
      <PriceLabel
        v-on:click.prevent="goToProduct(product)"
        :productData="product"
        :price="parseFloat(product.price)"
        ::aria-label="`${product.price} € Preis`"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ShoppinglistAddButton from "@/components/ShoppinglistAddButton.vue";
import PriceLabel from "@/components/PriceLabel.vue";
export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    detailLink: {
      type: Boolean,
      required: false,
      default: true
    },
    preview: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: { ShoppinglistAddButton, PriceLabel },
  data() {
    return {
      offsetPic: 0
    };
  },
  mounted() {
    const titleHeight = this.$refs.title.offsetHeight;
    if (this.product.portrait) {
      if (this.preview) {
        this.offsetPic = -10;
      } else {
        this.offsetPic = -40;
      }
    } else {
      if (titleHeight > 35) {
        if (this.preview) {
          this.offsetPic = -30;
        } else {
          this.offsetPic = -45;
        }
      } else {
        if (this.preview) {
          this.offsetPic = -20;
        } else {
          this.offsetPic = -40;
        }
      }
    }
  },
  methods: {
    goToProduct(product, openvideo) {
      
      if (!openvideo) openvideo = false;
      
      if (this.detailLink) {
        const routeObj = {
          name: "product",
          params: { nr: product.nr, slug: product.slug }
        }
        if (openvideo) {
          routeObj['query'] = { openvideo: openvideo }
        }
        this.$router.push(routeObj);
      } else if (this.preview && this.productHasVideo) {
        this.$emit("openVideo", product.youtubeId);
      }
    }
  },
  computed: {
    offsetPicPx() {
      return `${this.offsetPic}px`;
    },
    productHasVideo() {
      return this.product.youtubeId && this.product.youtubeId.length > 0;
    },
  }
};
</script>

<style lang="scss">
@import "./ProductsListItem";
</style>
